import { P2PMetadataEntityBase } from './abstract-p2p-metadata-entity-base';
import { IBizProcessEntity } from './interface-biz-process-entity';
import { AifCallType } from './aif-call-type';

/**
 * ä¸å¡æµç¨å®ä½æ½è±¡ç±»
 */
export abstract class BizProcessEntity extends P2PMetadataEntityBase implements IBizProcessEntity {
    BizEventMetadataId: string;

    BizEventId: string;

    BizActionMetadataId: string;

    BizActionId: string;

    IsEnabled: boolean;

    CallType: AifCallType;

}